import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import 'ngSmoothScroll';

import './style/site.style.sass';

import CommonModule from 'common';
import ComponentModule from './component';
import SceneModule from './scene';

export default angular
    .module('presentation', [
        uiRouter,
        'smoothScroll',

        CommonModule.name,
        ComponentModule.name,
        SceneModule.name
    ])
    .config(routerConfiguration);

/* @ngInject */
function routerConfiguration($locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/');
}



// WEBPACK FOOTER //
// ./src/presentation/index.js